<template>
  <v-menu offset-x :content-class="$style.menu" @input="toggleMenu">
    <template #activator="{ on }">
      <span v-on="on">
        <slot />
      </span>
    </template>

    <v-list v-if="hasListItems" :class="$style.list">
      <v-list-item v-for="item in listItems" :key="item.id" :class="$style['list-item']">
        <BaseButton :class="$style['list-button']" type="secondary" :href="item.url">
          <IconSelect v-if="item.icon" :icon="item.icon" :class="$style['list-button-icon']" />
          {{ item.title }}
        </BaseButton>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import IconSelect from '@/js/components/Shared/IconSelect/IconSelect.vue'

import QUICKFINDER_CONSTANTS from './utils/quickfinder-constants'

export default {
  name: 'QuickfinderFlyout',
  components: {
    IconSelect,
  },
  props: {
    listItems: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isOpen: false,
    }
  },
  computed: {
    hasListItems() {
      return this.listItems.length > 0
    },
  },
  methods: {
    toggleMenu(value) {
      if (this.hasListItems) {
        if (this.isOpen !== value) {
          this.isOpen = value

          this.$emit(QUICKFINDER_CONSTANTS.ACTIONS.TOGGLE_MENU, value)
        }
      }
    },
  },
}
</script>

<style lang="scss" module>
.menu {
  top: 13.75rem !important;
  right: 0 !important;
  left: auto !important;
  z-index: 4 !important;

  border-radius: 0 !important;
}

.list {
  padding: 1.25rem 5rem 1.25rem 1rem;
}

.list-item {
  padding: 0;

  &:not(:last-child) {
    margin-bottom: 0.625rem !important;
  }
}

.list-button {
  justify-content: flex-start;
  width: 100%;
  min-width: 20rem !important;

  * {
    color: var(--black) !important;
    font-weight: var(--font-weight-normal) !important;
    font-size: var(--font-lg) !important;
  }
}

.list-button-icon {
  margin-right: 0.625rem;
}
</style>
